import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import Leftnavigation from "./Leftnavigation";
import './style/departmentlogininfo.css';

const DepartmentTable = () => {
    const [departments, setDepartments] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [currentDepartment, setCurrentDepartment] = useState({});

    useEffect(() => {
        // Fetch departments data from the server when the component is mounted
        axios.get("https://gptkpm.in/backend/admin/departmentlogininfodisplay.php")
            .then(response => {
                console.log(response.data); // Check the structure of data received
                setDepartments(response.data);
            })
            .catch(error => {
                console.log("Error fetching data", error);
            });
    }, []);

    const handleEdit = (department) => {
        setCurrentDepartment(department); // Set the current department to edit
        setEditMode(true); // Enable edit mode
    };

    const handleUpdate = (event) => {
        event.preventDefault();

        const { department, username, password, table_name } = currentDepartment;

        // Send the update request to the server
        axios.post("https://gptkpm.in/backend/admin/departmentlogininfoupdate.php", {
            id: currentDepartment.id,
            department: department, // Include department name in the update
            username: username,
            password: password,
            table_name: table_name
        })
            .then(response => {
                if (response.data.success) {
                    alert("update successfully");
                    // Update the local state with the updated department data
                    setDepartments(prev => prev.map(dep => dep.id === currentDepartment.id ? currentDepartment : dep));
                    setEditMode(false); // Disable edit mode
                } else {
                    alert("Failed to update the department!");
                }
            })
            .catch(error => {
                console.log("Error updating data", error);
            });
    };

    const handleChange = (e) => {
        setCurrentDepartment({
            ...currentDepartment,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="main-container" style={{margin:"0"}}>
            <Header />

                <Leftnavigation />
                <h2>Departments Login Details</h2>

            <div className="table-container">

                <div style={{ width: "100%" }}>
                    <table className="department-table">
                        <thead>
                            <tr>
                                <th>Department</th>
                                <th>Username</th>
                                <th>Password</th>
                                <th>Table Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {departments.length > 0 ? (
                                departments.map(department => (
                                    <tr key={department.id}>
                                        <td>{department.department}</td>
                                        <td>{department.username}</td>
                                        <td>{department.password}</td>
                                        <td>{department.table_name}</td>
                                        <td>
                                            <button onClick={() => handleEdit(department)}>Update</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5">No departments available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Show the update form as a modal when edit mode is enabled */}
            {editMode && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close-btn" onClick={() => setEditMode(false)}>&times;</span>
                        <h3>Update Department</h3>
                        <form onSubmit={handleUpdate}>
                            
                            <br />
                            <label>
                                Username:
                                <input
                                    type="text"
                                    name="username"
                                    value={currentDepartment.username}
                                    onChange={handleChange}
                                />
                            </label>
                            <br />
                            <label>
                                Password:
                                <input
                                    type="password"
                                    name="password"
                                    value={currentDepartment.password}
                                    onChange={handleChange}
                                />
                            </label>
                            <br />
                            <label>
                                Table Name:
                                <input
                                    type="text"
                                    name="table_name"
                                    value={currentDepartment.table_name}
                                    onChange={handleChange}
                                />
                            </label>
                            <br />
                            <label>
                                Department Name:
                                <input
                                    type="text"
                                    name="department"
                                    value={currentDepartment.department}
                                    onChange={handleChange}
                                />
                            </label>
                            <button type="submit">Update</button>
                        </form>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default DepartmentTable;
